

export class DeviceBrandWithoutStatusOutput implements IDeviceBrandWithoutStatusOutput {
    /** The auto-generated id of the device brand  master */
    device_brand_id!: number;
    /** The device brand name with 255 character limit */
    device_brand_name!: string;

    constructor(data?: IDeviceBrandWithoutStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_brand_id = _data["device_brand_id"];
            this.device_brand_name = _data["device_brand_name"];
        }
    }

    static fromJS(data: any): DeviceBrandWithoutStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBrandWithoutStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_brand_id"] = this.device_brand_id;
        data["device_brand_name"] = this.device_brand_name;
        return data; 
    }
}

export interface IDeviceBrandWithoutStatusOutput {
    /** The auto-generated id of the device brand  master */
    device_brand_id: number;
    /** The device brand name with 255 character limit */
    device_brand_name: string;
}

